<div class="page-inner main markdown-content">
    <markdown ngPreserveWhitespaces [data]="data">
    </markdown>
</div>